import { FutureWorkByClientActionTypes, FutureWorkByClientState, READ_FUTURE_WORK_BY_CLIENT_DATA_REQUEST, READ_FUTURE_WORK_BY_CLIENT_DATA_SUCCESS, READ_FUTURE_WORK_BY_CLIENT_DATA_FAILURE } from "store/reducers/types/dashboard/futureWorkByClient";

const defaultState: FutureWorkByClientState = {
  isLoading: false,
  errorMessage: "",
};

export default function futureWorkByClient(state = defaultState, action: FutureWorkByClientActionTypes): FutureWorkByClientState {
  switch (action.type) {
    case READ_FUTURE_WORK_BY_CLIENT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_FUTURE_WORK_BY_CLIENT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_FUTURE_WORK_BY_CLIENT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
